import { Component, HostListener, OnInit } from '@angular/core';
import { UserService } from '../../../../../services/user';
import { ItemsService } from '../../../../../services/items.service';
import { StockTransferService } from '../../../../../services/stocktransferservice';
import { DeviceDetectorService } from '../../../../../services/device-detector.service';

@Component({
  selector: 'app-stocktransferhistorymobile',
  templateUrl: './stocktransferhistorymobile.component.html',
  styleUrl: './stocktransferhistorymobile.component.scss'
})
export class StocktransferhistorymobileComponent implements OnInit {
  isAdmin = false;
  isSubAdmin = false;
  superAdmin = false;
  isMobile = false;

  contentReady = true;
  noData = false;
  isLoadingMore = false;

  accountType!: string;

  transfers: any[] = [];
  allWareHouses: any[] = [];

  total = 0;
  pageSize = 10;
  currentPage = 1;
  hasMore = true;

  warehouseid: any = null;
  selectedWarehouseName = '';

  constructor(
    private _userService: UserService,
    private _ItemsService: ItemsService,
    private stockTransferService: StockTransferService,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();

    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accountType = data['user_type'];

        this.superAdmin = this.accountType === '10';
        this.isAdmin = this.accountType === '1';
        this.isSubAdmin = this.accountType === '6';

        if (this.isAdmin || this.superAdmin) {
          this.getWarehouses();
        }

        const firstWarehouseId = this.getActiveWarehouseId();
        this.loadData(1, firstWarehouseId, true);
      },
      error: (error) => {
        console.error(error);
        this.contentReady = false;
        this.noData = true;
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;
    const bottomReached = scrollPosition + windowHeight >= pageHeight - 120;

    if (bottomReached) {
      this.loadMore();
    }
  }

  getActiveWarehouseId(): string | null | undefined {
    if (this.warehouseid) {
      return this.warehouseid;
    }

    if (this.superAdmin) {
      return undefined;
    }

    return localStorage.getItem('posId') ?? undefined;
  }

  applyWareHouse(warehouseId: any, warehouseName: string = ''): void {
    this.warehouseid = warehouseId;
    this.selectedWarehouseName = warehouseName;

    this.resetList();

    const activeWarehouseId = this.getActiveWarehouseId();
    this.loadData(1, activeWarehouseId, true);
  }

  resetList(): void {
    this.currentPage = 1;
    this.total = 0;
    this.transfers = [];
    this.noData = false;
    this.hasMore = true;
    this.isLoadingMore = false;
  }

  getWarehouses(): void {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.allWareHouses = res.warehouse || [];
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  loadData(
    page: number,
    warehouseId?: string | null,
    reset: boolean = false
  ): void {
    if (reset) {
      this.contentReady = true;
    } else {
      this.isLoadingMore = true;
    }

    this.stockTransferService.getHistory(page, this.pageSize, warehouseId).subscribe({
      next: (res) => {
        const newData = res.data || [];

        this.total = res.total || 0;

        if (reset) {
          this.transfers = newData;
        } else {
          this.transfers = [...this.transfers, ...newData];
        }

        this.currentPage = page;
        this.noData = this.transfers.length === 0;

        this.hasMore =
          newData.length === this.pageSize &&
          this.transfers.length < this.total;

        this.contentReady = false;
        this.isLoadingMore = false;
      },
      error: (err) => {
        console.error(err);

        this.contentReady = false;
        this.isLoadingMore = false;

        if (this.transfers.length === 0) {
          this.noData = true;
        }
      }
    });
  }

  loadMore(): void {
    if (this.contentReady || this.isLoadingMore || !this.hasMore || this.noData) {
      return;
    }

    const nextPage = this.currentPage + 1;
    const activeWarehouseId = this.getActiveWarehouseId();

    this.loadData(nextPage, activeWarehouseId, false);
  }

  formatDate(date: string): string {
    if (!date) return '';

    const d = new Date(date);

    return d.toLocaleDateString('en-GB');
  }
}